import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';

import PropTypes from 'prop-types';

import Modal from 'components/Modal';
import Button from 'components/Button';
import Card from 'components/Card';

import Panel from 'components/Panel';
import FormField from 'components/FormField';
import TextInput from 'components/TextInput';
import ModalHeadline from 'components/ModalHeadline';

import useForm from 'hooks/useForm';

import {addhttps} from 'utils/utils';

function EditLinkModal({defaultValue, onClose, onSubmit}) {
	const {t} = useTranslation();

	const [isInvalidUrl, setIsInvalidUrl] = useState(false);

	const {fields, hasErrors, wasChanged} = useForm({
		fields: {
			link: {
				getDefaultValue: () => defaultValue,
				required: true,
			},
		},
	});

	const updateLink = e => {
		e.preventDefault();
		e.stopPropagation();
		const webUrl = addhttps(fields.link.value.trim());

		try {
			new URL(webUrl);
			onSubmit(webUrl);
		} catch {
			setIsInvalidUrl(true);
		}
	};

	const invalidUrlAlert = isInvalidUrl ? t('error_invalid_url') : null;
	const urlAlert = fields.link.error || invalidUrlAlert;

	const titleId = 'update-link-modal-title';

	return (
		<Modal
			id="update-link-modal"
			aria-labelledby={titleId}
			onRequestClose={onClose}
		>
			<Card variant="raised" as="form" onSubmit={updateLink}>
				<ModalHeadline
					title={t('actions_edit_web_link')}
					titleId={titleId}
					onClose={onClose}
				/>
				<Panel>
					<FormField
						label={t('modal_update_web_link_message')}
						alert={urlAlert}
					>
						<TextInput
							data-autofocus
							placeholder={t('links_placeholder')}
							value={fields.link.value}
							onChange={e => {
								fields.link.set(e.target.value);
								setIsInvalidUrl(false);
							}}
						/>
					</FormField>
				</Panel>

				<Panel align="center">
					<Button
						type="submit"
						variant="primary"
						icon="ok"
						isDisabled={
							hasErrors || Boolean(urlAlert) || !wasChanged
						}
					>
						{t('actions_done')}
					</Button>
				</Panel>
			</Card>
		</Modal>
	);
}

EditLinkModal.propTypes = {
	defaultValue: PropTypes.string,
	onClose: PropTypes.func.isRequired,
	onSubmit: PropTypes.func.isRequired,
};

export default EditLinkModal;
